
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppCurrencyEdit from "@/components/currencies/CurrencyEdit.vue";

import {CurrencyService} from "@/services/currency-service";
import Currency from "@/models/base/currency";


export default Vue.extend({
	data() {
		return {
			showCurrencyModal: false,
			currencies: CurrencyService.getCurrencies(),
			toEditCurrency: null as null | Currency
		};
	},
	computed: {
		path(): IBreadCrumb[] {
			return [
				{
					to: "/settings/sales", value: this.$ct("sale/purchase")
				},
				{
					value: this.$ct("multivaluta")
				}
			] as IBreadCrumb[];
		}
	},
	methods: {
		addCurrency(){
			this.showCurrencyModal = true;
		},
		editCurrency(id:number){
			this.toEditCurrency = this.currencies.filter((c)=>c.ID == id)[0];
			this.showCurrencyModal = true;
		},
		fetch(){
			this.currencies = CurrencyService.getCurrencies();
		}
	},
	components: {
		AppMobileFullScreenContainer,
		AppCurrencyEdit
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
